import CertificationBanner from '@/components/feature/CertificationBanner';

const features = [
  {
    icon: 'ri-drop-line',
    label: 'Waterproof Fabric',
    desc: 'Engineered to repel rain in any weather',
  },
  {
    icon: 'ri-sun-line',
    label: 'UV Resistant',
    desc: 'Blocks harmful UV rays for guest comfort',
  },
  {
    icon: 'ri-fire-line',
    label: 'Fire Rated',
    desc: 'Meets international fire safety standards',
  },
  {
    icon: 'ri-tools-line',
    label: 'Easy Setup',
    desc: 'Fast installation with minimal crew needed',
  },
];

export default function FabricFeatures() {
  return (
    <section className="pt-16 pb-0 bg-gray-50 border-t border-gray-100">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-gray-900 text-center mb-10">
          Built to the Highest Standards
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-white rounded-xl p-6 text-center hover:scale-105 transition-transform duration-300 cursor-default"
            >
              <div className="w-14 h-14 mx-auto mb-4 bg-teal-50 rounded-xl flex items-center justify-center">
                <i className={`${f.icon} text-3xl text-teal-400`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-1">{f.label}</h3>
              <p className="text-xs text-gray-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-16" style={{ marginBottom: '-1px' }}>
        <CertificationBanner />
      </div>
    </section>
  );
}
